import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/StatusBadge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { ExternalLink } from "lucide-react";

const PLANS = ["starter", "growth", "business", "enterprise"];

export default function PlatformStorefronts() {
  const [stores, setStores] = useState([]);

  const load = () => api.get("/platform/storefronts").then((r) => setStores(r.data));
  useEffect(() => { load(); }, []);

  const update = async (id, body) => {
    await api.patch(`/platform/storefronts/${id}`, body);
    toast.success("Storefront updated");
    load();
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Storefronts</h1>
        <p className="text-muted-foreground mt-1">Manage every store on the platform.</p>
      </div>
      <Card className="rounded-xl border-border overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Store</TableHead>
              <TableHead>Owner</TableHead>
              <TableHead className="text-right">Products</TableHead>
              <TableHead className="text-right">Orders</TableHead>
              <TableHead>Plan</TableHead>
              <TableHead>Status</TableHead>
              <TableHead></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {stores.map((s) => (
              <TableRow key={s.id} data-testid={`storefront-row-${s.id}`}>
                <TableCell>
                  <p className="font-medium">{s.name}</p>
                  <p className="text-xs text-muted-foreground">/store/{s.slug}</p>
                </TableCell>
                <TableCell className="text-sm">{s.owner_name}<br /><span className="text-xs text-muted-foreground">{s.owner_email}</span></TableCell>
                <TableCell className="text-right">{s.product_count}</TableCell>
                <TableCell className="text-right">{s.order_count}</TableCell>
                <TableCell>
                  <Select value={s.subscription_plan} onValueChange={(v) => update(s.id, { subscription_plan: v })}>
                    <SelectTrigger className="h-9 w-32 capitalize" data-testid={`plan-select-${s.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>{PLANS.map((p) => <SelectItem key={p} value={p} className="capitalize">{p}</SelectItem>)}</SelectContent>
                  </Select>
                </TableCell>
                <TableCell><StatusBadge status={s.status} /></TableCell>
                <TableCell>
                  <div className="flex items-center gap-2">
                    <a href={`/store/${s.slug}`} target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-foreground"><ExternalLink className="h-4 w-4" /></a>
                    {s.status === "active" ? (
                      <Button variant="ghost" size="sm" className="text-destructive h-8" onClick={() => update(s.id, { status: "suspended" })} data-testid={`suspend-${s.id}`}>Suspend</Button>
                    ) : (
                      <Button variant="ghost" size="sm" className="text-emerald-600 h-8" onClick={() => update(s.id, { status: "active" })} data-testid={`activate-${s.id}`}>Activate</Button>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {stores.length === 0 && <p className="p-8 text-center text-muted-foreground">No storefronts yet.</p>}
      </Card>
    </div>
  );
}
